import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入组件库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({ showSpinner: false })

// 引入axios
import axios from '../src/utils/request.js';
import apiurl from '@/interface/apiurls.js';
import time from '@/utils/moment'
import empty from '@/utils/empty.js'

// 引入字体文件
import '@/utils/adapter.js'
// 引入样式初始化文件
import '../src/css/reset.css'
import '../src/css/element.css'

// 引入字体图标库
import '../src/assets/iconfont/iconfont.css'

// 引入权限判断
import permission from '@/utils/permission'
import inserted from '@/utils/permission/hasPermi'

// 菜单权限
import './permission.js'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(permission)
Vue.prototype.$axios = axios
Vue.prototype.$apiurl = apiurl
Vue.prototype.$time = time

Vue.prototype.$empty = empty
Vue.prototype.$hasPermission = inserted.insertedHandler


router.beforeEach((to, from, next) => {
  // 是否去的是会员模块
  let vip_flag = to.matched.some(item => item.name == '入会申请' ||  item.name == '会员企业' || item.name == '企业登录' || item.name == '企业注册')

  if (to.matched.some(item => item.name == '登录' || item.name == '企业登录' || item.name == '企业注册')) { //判断是否去登页
    next()
  } else {
    if(sessionStorage.getItem('token')){
      next()
    }else{
      if(vip_flag){
        next({
          path:'/login-member'
        })
      }else{
        next({
          path:'/'
        })
      }
    }
  }
});
// 自定义指令。解决 el-radio-group 会报 Blocked aria-hidden错误
Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    const ariaEls = el.querySelectorAll('.el-radio__original')
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden')
    })
  }
})          
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
 